/* Bulk ordering from the product page, open to everyone. The tier counts every size together,
   as the discount function does at checkout, so we never quote a price checkout refuses. */
(function () {
  var roots = document.querySelectorAll('[data-bulk-order]');
  Array.prototype.forEach.call(roots, init);

  function init(root) {
    var configEl = root.querySelector('[data-bo-config]');
    if (!configEl) return;

    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    var TEXT = cfg.text || {};
    var TIERS = (cfg.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
    var canPersonalize = root.getAttribute('data-personalize') === 'true';

    var el = {
      gate: root.querySelector('[data-bo-gate]'),
      cancel: root.querySelector('[data-bo-cancel]'),
      me: root.querySelector('[data-bo-me]'),
      team: root.querySelector('[data-bo-team]'),
      wizard: root.querySelector('[data-bo-wizard]'),
      colour: root.querySelector('[data-bo-colour]'),
      colourLabel: root.querySelector('[data-bo-colour-label]'),
      chips: root.querySelector('[data-bo-chips]'),
      ladder: root.querySelector('[data-bo-ladder]'),
      body: root.querySelector('[data-bo-body]'),
      table: root.querySelector('[data-bo-table]'),
      empty: root.querySelector('[data-bo-empty]'),
      next: root.querySelector('[data-bo-next]'),
      error: root.querySelector('[data-bo-error]'),
      meter: root.querySelector('[data-bo-meter]'),
      meterFill: root.querySelector('[data-bo-meter-fill]'),
      meterText: root.querySelector('[data-bo-meter-text]'),
      runCount: root.querySelector('[data-bo-run-count]'),
      runTotal: root.querySelector('[data-bo-run-total]'),
      runSave: root.querySelector('[data-bo-run-save]'),
      image: root.querySelector('[data-bo-image]')
    };

    var qty = {};
    var busy = false;

    function money(cents) {
      var fmt = cfg.moneyFormat || '${{amount}}';
      var n = cents / 100;
      var withComma = function (v) { return v.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
      return fmt
        .replace('{{amount_no_decimals_with_comma_separator}}', withComma(String(Math.round(n))))
        .replace('{{amount_with_comma_separator}}', withComma(n.toFixed(2)).replace('.', ','))
        .replace('{{amount_no_decimals}}', withComma(String(Math.round(n))))
        .replace('{{amount}}', withComma(n.toFixed(2)));
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function optionAt(v, i) { return i >= 0 && v.options ? v.options[i] : ''; }

    function colours() {
      var seen = [];
      cfg.variants.forEach(function (v) {
        var c = optionAt(v, cfg.colourIndex);
        if (c && seen.indexOf(c) === -1) seen.push(c);
      });
      return seen;
    }

    function selectedColour() { return el.colour ? el.colour.value : ''; }

    function shotFor(colour) {
      var match = cfg.variants.filter(function (v) {
        return optionAt(v, cfg.colourIndex) === colour && v.image;
      })[0];
      return match ? match.image : null;
    }

    // Out of stock sizes are left out, not shown disabled.
    function rows() {
      return cfg.variants.filter(function (v) {
        if (!v.available) return false;
        if (cfg.colourIndex >= 0 && optionAt(v, cfg.colourIndex) !== selectedColour()) return false;
        return true;
      });
    }

    function pooled() {
      var n = 0;
      Object.keys(qty).forEach(function (id) { n += qty[id] || 0; });
      return n;
    }

    function tierFor(n) {
      var earned = null;
      TIERS.forEach(function (t) { if (n >= t.min) earned = t; });
      return earned;
    }

    function unitPrice(base, n) {
      var t = tierFor(n);
      return t ? Math.round(base * (100 - t.percent) / 100) : base;
    }

    function tierLabel(i) {
      if (i === -1) {
        if (!TIERS.length) return '';
        return TIERS[0].min > 2 ? '1-' + (TIERS[0].min - 1) : '1';
      }
      var next = TIERS[i + 1];
      return next ? TIERS[i].min + '-' + (next.min - 1) : TIERS[i].min + '+';
    }

    function cheapestBase() {
      return rows().reduce(function (a, v) { return Math.min(a, v.price); }, Infinity);
    }

    /* The hidden select stays the real control, for keyboard and screen reader users. */
    function renderChips() {
      if (!el.chips) return;
      var on = selectedColour();
      el.chips.innerHTML = colours().map(function (c) {
        var shot = shotFor(c);
        return '<button type="button" class="snc-bo__chip' + (c === on ? ' is-on' : '') + '" role="radio" aria-checked="' +
               (c === on ? 'true' : 'false') + '" data-bo-chip="' + esc(c) + '" title="' + esc(c) + '">' +
               (shot ? '<img src="' + esc(shot) + '" alt="">' : '<span>' + esc(c) + '</span>') +
               '</button>';
      }).join('');
      if (el.colourLabel) el.colourLabel.textContent = on;
      var shot = shotFor(on);
      if (shot && el.image) el.image.src = shot;
    }

    function renderLadder() {
      if (!el.ladder) return;
      var n = pooled();
      var current = tierFor(n);
      var active = current ? TIERS.indexOf(current) : -1;
      var base = cheapestBase();
      var rungs = [{ i: -1, percent: 0 }].concat(TIERS.map(function (t, i) { return { i: i, percent: t.percent }; }));
      el.ladder.innerHTML = rungs.map(function (r) {
        var cls = 'snc-bo__rung' + (r.i === active ? ' is-on' : r.i < active ? ' is-past' : '');
        var price = isFinite(base) ? money(Math.round(base * (100 - r.percent) / 100)) : '';
        var off = r.percent ? (TEXT.off || '%d% off').replace('%d', r.percent) : (TEXT.listPrice || 'List price');
        return '<li class="' + cls + '"><span class="snc-bo__rung-range">' + esc(tierLabel(r.i)) + '</span>' +
               '<span class="snc-bo__rung-price">' + esc(price) + '</span>' +
               '<span class="snc-bo__rung-off">' + esc(off) + '</span></li>';
      }).join('');
    }

    function renderBody() {
      var list = rows();
      el.empty.hidden = list.length > 0;
      el.table.hidden = list.length === 0;
      el.body.innerHTML = list.map(function (v) {
        var size = esc(optionAt(v, cfg.sizeIndex) || cfg.unitLabel || 'Quantity');
        return '<tr data-bo-row="' + v.id + '">' +
          '<th scope="row" class="snc-bo__sizecell">' + size + '</th>' +
          '<td><span class="snc-bo__step">' +
            '<button type="button" data-bo-bump="' + v.id + ':-1" aria-label="Fewer ' + size + '">&minus;</button>' +
            '<input type="number" min="0" step="1" inputmode="numeric" value="' +
              (qty[v.id] || '') + '" data-bo-qty="' + v.id + '" data-price="' + v.price + '" aria-label="' + size + '">' +
            '<button type="button" data-bo-bump="' + v.id + ':1" aria-label="More ' + size + '">+</button>' +
          '</span></td>' +
          '<td class="snc-bo__unit" data-bo-unit="' + v.id + '"></td>' +
          '<td class="snc-bo__linetotal" data-bo-line="' + v.id + '"></td>' +
        '</tr>';
      }).join('');
      refreshLive();
    }

    function refreshLive() {
      var n = pooled();
      var total = 0, list = 0;
      var t = tierFor(n);

      rows().forEach(function (v) {
        var q = qty[v.id] || 0;
        var unit = unitPrice(v.price, n);
        var line = unit * q;
        total += line;
        list += v.price * q;
        var row = el.body.querySelector('[data-bo-row="' + v.id + '"]');
        if (row) row.classList.toggle('has-qty', q > 0);
        var unitCell = el.body.querySelector('[data-bo-unit="' + v.id + '"]');
        if (unitCell) {
          unitCell.innerHTML = (t ? '<s>' + esc(money(v.price)) + '</s>' : '') + esc(money(unit)) +
                               ' <span>' + esc(TEXT.each || 'each') + '</span>';
        }
        var cell = el.body.querySelector('[data-bo-line="' + v.id + '"]');
        if (cell) cell.textContent = q > 0 ? money(line) : '';
      });

      if (el.runCount) {
        el.runCount.textContent = n === 0 ? '' :
          n === 1 ? (TEXT.itemsOne || '1 item') : (TEXT.itemsOther || '%d items').replace('%d', n);
      }
      if (el.runTotal) el.runTotal.textContent = money(total);
      var saved = list - total;
      if (el.runSave) {
        el.runSave.hidden = saved <= 0;
        if (saved > 0) el.runSave.textContent = (TEXT.youSave || 'You save %s').replace('%s', money(saved));
      }

      var next = null;
      TIERS.forEach(function (tt) { if (!next && n < tt.min) next = tt; });
      if (el.meter) {
        el.meter.hidden = !TIERS.length;
        if (TIERS.length) {
          if (next) {
            var floor = t ? t.min : 0;
            var span = next.min - floor;
            var pct = span > 0 ? Math.min(100, Math.round(((n - floor) / span) * 100)) : 0;
            el.meterFill.style.width = Math.max(4, pct) + '%';
            el.meterText.textContent = (TEXT.moreFor || '%c more for %d% off').replace('%c', next.min - n).replace('%d', next.percent);
            el.meterText.classList.remove('is-done');
          } else {
            el.meterFill.style.width = '100%';
            el.meterText.textContent = TEXT.unlocked || 'You have the best price';
            el.meterText.classList.add('is-done');
          }
        }
      }

      renderLadder();
      el.next.disabled = busy || n === 0;
    }

    function addToCart() {
      var items = Object.keys(qty)
        .filter(function (id) { return qty[id] > 0; })
        .map(function (id) { return { id: Number(id), quantity: qty[id] }; });
      if (!items.length) return;

      busy = true;
      el.next.textContent = TEXT.adding || 'Adding...';
      el.next.disabled = true;
      el.error.hidden = true;

      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (b) { throw new Error(b.description || b.message || ''); });
          return res.json();
        })
        .then(function () {
          busy = false;
          el.next.textContent = TEXT.addToCart || 'Add to cart';
          closeAll();
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'bulk' } }));
          document.dispatchEvent(new CustomEvent('sannico:cart:open'));
        })
        .catch(function (err) {
          busy = false;
          el.next.textContent = TEXT.addToCart || 'Add to cart';
          el.error.textContent = err.message || TEXT.failed || 'Could not add to cart.';
          el.error.hidden = false;
          el.next.disabled = pooled() === 0;
        });
    }

    var returnFocus = null;

    // The wizard fills the screen, so stop the page behind it from scrolling.
    function openWizard() {
      if (!returnFocus) returnFocus = document.activeElement;
      el.gate.hidden = true;
      el.wizard.hidden = false;
      document.body.style.overflow = 'hidden';
      if (window.sannicoTrapFocus) window.sannicoTrapFocus(el.wizard);
      qty = {};
      el.error.hidden = true;
      renderChips();
      renderBody();
      var inner = root.querySelector('.snc-bo__rail-inner');
      if (inner) inner.scrollTop = 0;
    }

    function closeAll() {
      el.gate.hidden = true;
      el.wizard.hidden = true;
      document.body.style.removeProperty('overflow');
      if (window.sannicoReleaseFocus) {
        window.sannicoReleaseFocus(el.wizard);
        window.sannicoReleaseFocus(el.gate);
      }
      if (returnFocus && returnFocus.focus) returnFocus.focus();
      returnFocus = null;
    }

    function openGate() {
      returnFocus = document.activeElement;
      if (!canPersonalize) { openWizard(); return; }
      el.gate.hidden = false;
      document.body.style.overflow = 'hidden';
      if (window.sannicoTrapFocus) window.sannicoTrapFocus(el.gate);
    }

    if (el.colour) {
      el.colour.innerHTML = colours().map(function (c) {
        return '<option value="' + esc(c) + '">' + esc(c) + '</option>';
      }).join('');
      el.colour.addEventListener('change', function () {
        qty = {};
        renderChips();
        renderBody();
      });
      if (el.chips) el.chips.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-bo-chip]');
        if (!chip) return;
        el.colour.value = chip.getAttribute('data-bo-chip');
        el.colour.dispatchEvent(new Event('change'));
      });
    }

    el.cancel.addEventListener('click', closeAll);
    var wizCancel = root.querySelector('[data-bo-wiz-cancel]');
    if (wizCancel) wizCancel.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && (!el.gate.hidden || !el.wizard.hidden)) closeAll();
    });
    /* "Just for me" opens the customizer on sizes, "for a team" on the roster. No printing opens the plain size grid. */
    function handOff(mode) {
      if (document.querySelector('[data-customizer]')) {
        el.gate.hidden = true;
        document.dispatchEvent(new CustomEvent('sannico:customize', { detail: { mode: mode } }));
        return;
      }
      openWizard();
    }
    el.me.addEventListener('click', function () { handOff('me'); });
    el.team.addEventListener('click', function () { handOff('team'); });

    el.body.addEventListener('input', function (e) {
      var input = e.target.closest('[data-bo-qty]');
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      qty[input.getAttribute('data-bo-qty')] = n;
      refreshLive();
    });

    el.body.addEventListener('click', function (e) {
      var bump = e.target.closest('[data-bo-bump]');
      if (!bump) return;
      var parts = bump.getAttribute('data-bo-bump').split(':');
      var input = el.body.querySelector('[data-bo-qty="' + parts[0] + '"]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(parts[1], 10));
      input.value = next || '';
      qty[parts[0]] = next;
      refreshLive();
    });

    el.next.addEventListener('click', function () {
      if (pooled() > 0 && !busy) addToCart();
    });

    document.addEventListener('sannico:sizegrid', openWizard);

    var opener = document.querySelector('[data-bulk-open]');
    if (opener) opener.addEventListener('click', openGate);
  }
})();
